<template>
  <div>
    <!-- <vuex-breadcrumb></vuex-breadcrumb> -->
    <showing-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></showing-create>
  </div>
</template>

<script>
// import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ShowingCreate from './ShowingCreate.vue'

export default {
  components: {
    // VuexBreadcrumb,
    ShowingCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>